<template>
  <div class="blocContainer">
    <div class="container_title">
      <b-icon icon="check-circle-fill"></b-icon>
      <span class="title">{{ title }}</span>
    </div>
    <div class="content">{{ content }}</div>
  </div>
</template>
<script>
export default {
  props: ["title", "content"],
};
</script>
<style lang="scss" scoped>
@import "../../../../../sass/_variables.scss";
.blocContainer {
  padding: 20px;
  .container_title {
    text-align: left;
    display: flex;
    align-items: center;
    .title {
      font-weight: bold;
      font-size: $mf_ft_size_subtitle;
    }
    .b-icon.bi {
      $size: 25px;
      color: $blue_color;
      height: $size;
      width: $size;
      margin-right: 10px;
    }
  }
  .content {
    color: $mf_ft_color_white;
    font-size: 1em;
    text-align: left;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    opacity: 1;
  }
}
</style>
